import React from 'react';
import styled from 'styled-components';
import {
  accountSelectionListId,
  IA2AccountDropdownSearchInput,
} from './styles';
import { useAccountDropdownSearch } from './useAccountDropdownSearch';
import { IA2AccountDropdownTypeSection } from './IA2AccountDropdownTypeSection';
import { IA2AccountDropdownInfoCard } from './IA2AccountDropdownInfoCard';
import { useAccountDropdownContext } from './AccountDropdownProvider';
import { IA2AccountDropdownFooterLinks } from './IA2AccountDropdownFooterLinks';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { getAccountTypeListLabel } from './AccountTypeLocalizationKeyMapping';
import { ErrorLoadingAccountsMessage } from 'src/features/header/components/AccountDropdown/ErrorLoadingAccountsMessage';
import { NoAccountsMessage } from 'src/features/header/components/AccountDropdown/NoAccountsMessage';
import { Flex } from '@amzn/storm-ui';

const SEARCH_DISPLAY_COUNT = 10;

const AccountSwitcherContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.xsmall.default};
`;

const MobileAccountListContainer = styled.div`
  flex: 1;
  position: relative;
  padding: 0 ${({ theme }) => theme.spacing.xsmall.default};
  border-top: ${({ theme }) => theme.border.subtle.default};
`;

const AccountDropdownWithSearchContainer = styled(Flex).attrs({
  direction: 'column',
  alignItems: 'inherit',
})``;

export const IA2MobileAccountDropdown: React.VFC = () => {
  const { accounts, accountCounter, loadingStatus } =
    useAccountDropdownContext();

  const bundle = useAccountDropdownBundle();
  const { onSearch, accountTypeList, onClear, searchValue } =
    useAccountDropdownSearch({
      accounts,
    });
  const isFailedLoadingAccountData = loadingStatus === 'error';

  const searchAccountPlaceholder = bundle.getMessage(
    'account-dropdown-placeholder',
  );

  return (
    <AccountDropdownWithSearchContainer data-ccx-e2e-id="aac-mobile-account-dropdown-wrapper">
      <AccountSwitcherContainer>
        <IA2AccountDropdownInfoCard />
        {accountCounter > SEARCH_DISPLAY_COUNT && (
          <IA2AccountDropdownSearchInput
            id="account-switcher-search"
            placeholder={searchAccountPlaceholder}
            onChange={onSearch}
            onClear={onClear}
            fullWidth={true}
            label={searchAccountPlaceholder}
            value={searchValue}
          />
        )}
      </AccountSwitcherContainer>
      <MobileAccountListContainer id={accountSelectionListId}>
        {isFailedLoadingAccountData && <ErrorLoadingAccountsMessage />}
        {!isFailedLoadingAccountData && accountTypeList.length === 0 && (
          <NoAccountsMessage />
        )}
        {!isFailedLoadingAccountData &&
          accountTypeList.length > 0 &&
          accountTypeList.map((accountTypeItem) => {
            return (
              <IA2AccountDropdownTypeSection
                key={accountTypeItem.accountType}
                accounts={accountTypeItem.accounts}
                label={getAccountTypeListLabel(
                  accountTypeItem.accountType,
                  bundle,
                )}
                type={accountTypeItem.accountType}
              />
            );
          })}
      </MobileAccountListContainer>
      <IA2AccountDropdownFooterLinks />
    </AccountDropdownWithSearchContainer>
  );
};
